// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import React, { FC } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import { orderSubtitleSpacingStyles } from "@store/Themes/common/mixins/order";
import { orderProps } from "@store/Themes/common/props/order";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
/* Starter Custom Code - End */

export interface CartLinesListHeaderStyles {
    wrapper?: InjectableCss;
    productCountText?: TypographyPresentationProps;
    checkboxGroup?: FieldSetGroupPresentationProps<CheckboxGroupComponentProps>;
    condensedCheckbox?: CheckboxPresentationProps;
}

export const cartLinesListHeaderStyles: CartLinesListHeaderStyles = {
    wrapper: {
        css: orderSubtitleSpacingStyles(),
    },
    productCountText: orderProps.subtitle,
};

const CartLinesListHeader: FC<{
    productsCount: number;
    isCondensed: boolean;
    hideCondensedSelector?: boolean;
    onChangeIsCondensed?: (event: React.SyntheticEvent, value: boolean) => void;
    extendedStyles?: CartLinesListHeaderStyles;
    // Starter Custom Code
    overridedStyles?: CartLinesListHeaderStyles;
}> = ({
    productsCount,
    onChangeIsCondensed,
    extendedStyles,
    isCondensed,
    hideCondensedSelector,
    // Starter Custom Code
    overridedStyles,
}) => {
    const styles = useExpandProps(cartLinesListHeaderStyles, extendedStyles, overridedStyles); // Starter Custom Code

    const productsLabel = productsCount === 1 ? translate("Item") : translate("Items"); // Starter Custom Code

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.productCountText} /* Starter Removed - as */>
                {}
                {productsCount} {productsLabel /* Starter Custom Code */}
            </Typography>
            {/* Starter Removed - hideCondensedSelector */}
        </StyledWrapper>
    );
};

export default CartLinesListHeader;
